import React, { Component } from 'react';
import * as d3 from 'd3';
import withTitle from '../components/withTitle';
import chart from './d3/d3-riskreturnchart';

class RiskReturnChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.chart = chart()
      .width(this.props.width)
      .height(this.props.height)
      .label({ riskStatistic: this.props.riskStatistic, returnStatistic: this.props.returnStatistic })
      .statistics(this.props.statistics)
      .on('selected', this.props.onSelected)
      .asset(this.props.asset)
      .classes(this.props.classes);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  componentDidUpdate() {
    this.chart
      .width(this.props.width)
      .height(this.props.height)
      .label({ riskStatistic: this.props.riskStatistic, returnStatistic: this.props.returnStatistic })
      .statistics(this.props.statistics)
      .asset(this.props.asset)
      .classes(this.props.classes);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  componentWillUnmount() {
    this.chart
      .cleanup();
  }

  render() {
    return <div ref="chart" style={{ width: '100%' }} />
  }
}

export default withTitle(RiskReturnChart);


// WEBPACK FOOTER //
// ./src/charts/RiskReturnChart.js